/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import IosSpinner from './loader/IosSpinner';
import { DARK_GREY } from '../../styles/colors';
import { UNSELECTABLE_TEXT } from '../../styles/styles';

const ioSpinner = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;


/**
 * StatusButton: a component that accepts an image and a bunch of other information. This renders the image in a border
 * with the option of showing a loading state, handling clicks, showing tooltips, transitioning between different states
 * (done by changing the color).
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class StatusButton extends React.PureComponent<{
  image: string;
  borderColor: string;
  isLoading: boolean;
  toolTipText: string;
  borderWidth: number;
  height: number;
  width: number;
  disable: boolean;
  disableBorderColor: string;
  disableToolTip: string;
  fillMode: 'inscribe' | 'fill';
  imgCss?: SerializedStyles;
  rootCss?: SerializedStyles;
  handleClick: () => void;
  /**
   * The border radius style (include units)
   */
  borderRadius?: string,
}> {
  public static defaultProps = {
    borderRadius:       100,
    disable:            false,
    disableBorderColor: DARK_GREY,
    disableToolTip:     'Disabled',
    fillMode:           'inscribe',
  };


  private onClick = () => this.props.disable ? undefined : this.props.handleClick();


  public render = () => (
    <div onClick={this.onClick}
         css={css`
           display: flex;
           align-items: center;
           justify-content: center;
           height: ${this.props.height}px;
           width: ${this.props.width}px;
           border: 2px solid;
           position: relative;
           transition: border-color 500ms ease-in;
           overflow: hidden;
           border: ${this.props.borderWidth}px solid;
           cursor: ${this.props.disable ? 'not-allowed' : 'pointer'};
           border-radius: ${this.props.borderRadius};
           border-color: ${this.props.disable ? this.props.disableBorderColor : this.props.borderColor};
           opacity: ${this.props.disable ? .5 : 1};
           ${this.props.rootCss};
         `}>
      { // Loading
         this.props.isLoading && <IosSpinner rootCss={ioSpinner}/>

      }
      <img title={this.props.disable ? this.props.disableToolTip : this.props.toolTipText}
           src={this.props.image}
           alt={this.props.toolTipText}
           css={css`
             width: ${this.props.fillMode === 'fill' ? '100%' : '75%'};  // 75% is a good approx. of an inscribed square
             height: ${this.props.fillMode === 'fill' ? '100%' : '75%'}; // 75% is a good approx. of an inscribed square
             ${UNSELECTABLE_TEXT};
             ${this.props.imgCss};
           `}/>
    </div>
  );
}
